import { useEffect, useRef } from "react";

//@ts-ignore

import { PlayerEvent, Player } from "bitmovin-player";

import "bitmovin-player/bitmovinplayer-ui.css";

//@ts-ignore

import { Box } from "@mui/material";
import { getCurrentAuth } from "../../Hooks/http-server";
import { useLoadData } from "../../Context/LoadDataContext";

declare global {
  interface Window {
    bitmovin: any;
  }
}
// v1/condensed-game-search
const HighlightPlayer = ({ url }: { url: string }) => {
  // Event handler for seek end
  const { playerRef } = useLoadData();
  useEffect(() => {
    // Function to initialize JW Player
    if (!playerRef.current && !url) return;
    var conf: any = {
      key: "e090fca9-4a8f-4330-ab80-1ce2c58c9218",
      location: {
        ui: "https://cdn.bitmovin.com/player/web/8/bitmovinplayer-ui.js",
        ui_css: "https://cdn.bitmovin.com/player/web/8/bitmovinplayer-ui.css",
      },

      playback: {
        autoplay: true,
      },
      cast: {
        enable: true,
      },
    };

    var source = {
      hls: url,
    };
    playerRef.current = new Player(
      document.getElementById("linus-bitmovin-player") as any,
      conf
    );

    // Setup the player
    playerRef.current
      .load(source)
      .then(() => {})
      .then(
        () => {
          console.log("Successfully loaded the HLS file");
        },
        (error: any) => {
          console.error("Error while loading the HLS file", error);
        }
      );

    playerRef.current.on(PlayerEvent.PlaybackFinished, () => {});

    return () => {
      playerRef.current.unload();
    };
  }, [url]);
  return (
    <Box sx={{ position: "relative", py: 2 }}>
      <Box className="player-container" id={"linus-bitmovin-player"}></Box>
    </Box>
  );
};

export const HighlightPlayerPersonalized = ({
  url,
  videoList,
  setActiveClip,
  findCurrentClipTime,
}: {
  url: string;
  videoList: any;
  setActiveClip: any;
  findCurrentClipTime: any;
}) => {
  // Event handler for seek end
  const { playerRef } = useLoadData();
  useEffect(() => {
    // Function to initialize JW Player
    if (!playerRef.current && !url) return;
    var conf: any = {
      key: "e090fca9-4a8f-4330-ab80-1ce2c58c9218",
      location: {
        ui: "https://cdn.bitmovin.com/player/web/8/bitmovinplayer-ui.js",
        ui_css: "https://cdn.bitmovin.com/player/web/8/bitmovinplayer-ui.css",
      },

      playback: {
        autoplay: true,
      },
      cast: {
        enable: true,
      },
    };

    var source = {
      hls: url,
    };
    playerRef.current = new Player(
      document.getElementById("linus-bitmovin-player") as any,
      conf
    );

    // Setup the player
    playerRef.current
      .load(source)
      .then(() => {})
      .then(
        () => {
          console.log("Successfully loaded the HLS file");
        },
        (error: any) => {
          console.error("Error while loading the HLS file", error);
        }
      );

    playerRef.current.on(PlayerEvent.PlaybackFinished, () => {});
    playerRef.current?.on(PlayerEvent.TimeChanged, function () {
      var hasPlayedTime = playerRef.current.getCurrentTime("relativetime");
      const findIndex = videoList.findIndex(
        (el: any, index: any) =>
          hasPlayedTime >= findCurrentClipTime(el, index) &&
          hasPlayedTime <
            findCurrentClipTime(el, index) + parseFloat(el?.duration) + 2
      );
      if (findIndex !== -1) {
        setActiveClip(videoList[findIndex]?.game_event_id);
      }
    });
    return () => {
      playerRef.current.unload();
    };
  }, [url, videoList]);
  return (
    <Box sx={{ position: "relative", py: 2, width: "100%" }}>
      <Box
        className="player-container"
        sx={{ width: "100%" }}
        id={"linus-bitmovin-player"}
      ></Box>
    </Box>
  );
};
export default HighlightPlayer;
